function BrandHeader() {
  return (
    <header className="brand-header">
      <div className="brand-mark">C</div>
      <div>
        <div className="brand-title">
          Crypto<span>Fog</span>
        </div>
        <div className="brand-subtitle">Майнинг, задания и награды в одном приложении</div>
      </div>
    </header>
  );
}

export default BrandHeader;
